export const WEBSITE_WIDGET_SCRIPT_KEY = "widget-sdk/tldr-wa-widget.js";

export interface WebsiteWidgetSettings {
  whatsappNumber: string;
  prefilledMessage: string;
  accentColor: string;
}

export const DEFAULT_WEBSITE_WIDGET_SETTINGS: WebsiteWidgetSettings = {
  whatsappNumber: "",
  prefilledMessage: "Hi! I came from your website and wanted to know more.",
  accentColor: "#25D366",
};

export function normalizeWidgetAccentColor(value: string | undefined | null): string {
  if (!value) {
    return DEFAULT_WEBSITE_WIDGET_SETTINGS.accentColor;
  }

  const normalized = value.trim();
  return /^#[0-9a-fA-F]{6}$/.test(normalized)
    ? normalized.toUpperCase()
    : DEFAULT_WEBSITE_WIDGET_SETTINGS.accentColor;
}
